import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiClient } from "@/api/client";
import type { components } from "@/api/schema";

import { ratioKeys } from "./query-keys";

type SetRatioBody = components["schemas"]["SetRatioRequest"];

export function useSetRatio() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ sku, body }: { sku: string; body: SetRatioBody }) => {
      const { error } = await apiClient.PUT("/v1/inventory-ratio/{sku}", {
        params: { path: { sku } },
        body,
      });
      if (error) throw error;
    },
    onSuccess: (_data, { sku }) => {
      void qc.invalidateQueries({ queryKey: ratioKeys.lists });
      void qc.invalidateQueries({ queryKey: ratioKeys.detail(sku) });
    },
  });
}
